import { useCitrusUser } from './useCitrusUser';
/**
 * Gets localization (translation) for a given type/region
 *
 * @since v1.0.0
 * @template TType
 * @template TLocalization
 * @param {Map<TType, TLocalization>} localizationMap All of the available localizations
 * @returns {TLocalization} The appropriate translations
 * @example
 * import { useLocalization } from '@citrus/user';
 * ...
 * const lang = useLocalization(localizationMap);
 */
export var useLocalization = function (localizationMap) {
    var _a;
    var localizeTo = (((_a = useCitrusUser()) === null || _a === void 0 ? void 0 : _a.lang) || 'en-US');
    return localizationMap.has(localizeTo) ? localizationMap.get(localizeTo) : localizationMap.get('en-US');
};
